import { iconName } from "../icons/Icons";

export const StyleVariants = ['default', 'emphasized', 'destructive', 'strike-through'] as const;
export type StyleVariant = typeof StyleVariants[number];

export type IconContentDefinition = { type:'icon', iconName:iconName, styleVariantOverride?:StyleVariant };
export type TextContentDefinition = { type:'text', text:string, styleVariantOverride?:StyleVariant, flex?:string };
export type TextWithSubtextContentDefinition = { type:'textWithSubtext', text:string, subtext:string, styleVariantOverride?:StyleVariant, subtextStyleVariantOverride?:StyleVariant, flex?:string };
export type NoneContentDefinition = { type:'none' };

export type LeadingContentType = NoneContentDefinition | IconContentDefinition;
export type TrailingContentType = NoneContentDefinition | IconContentDefinition | TextContentDefinition;
export type PrimaryContentType = TextContentDefinition | TextWithSubtextContentDefinition;


export type SeparatorMenuItemDefinition = {
    type:'separator',
    dummy?:void
};

export type LabelMenuItemDefinition = {
    type:'label',
    text:string
};

export type CommonMenuItemDefinition = {
    styleVariant:StyleVariant,
    selectedState?:boolean,
    toolTip?:string,
    onClick?:()=>void,
    popupMenu?:{
        icon?:iconName,
        content:AmorgMenuContent[]
    }
}

export type LeadingContentMenuItemDefinition =  CommonMenuItemDefinition &
{
    type:'leadingContent',
    leadingContent:LeadingContentType,
    primaryContent:PrimaryContentType
}

export type TrailingContentMenuItemDefinition =  CommonMenuItemDefinition &
{
    type:'trailingContent',
    trailingContent:TrailingContentType,
    primaryContent:PrimaryContentType
}

export type LeadingTrailingContentMenuItemDefinition =  CommonMenuItemDefinition &
{
    type:'leadingTrailingContent',
    leadingContent:LeadingContentType,
    primaryContent:PrimaryContentType,
    trailingContent:TrailingContentType,
}

export type AmorgMenuContent = 
    SeparatorMenuItemDefinition |
    LabelMenuItemDefinition |
    LeadingContentMenuItemDefinition |
    TrailingContentMenuItemDefinition |
    LeadingTrailingContentMenuItemDefinition;